import { ButtonTypes } from "../../../../../components/Button";
import { SelectSheetOption } from "../../../../../components/MobileForm";
import { DetailButton, ProgressFilterOption } from "./types";

export const PAGE_SIZES = [10, 25, 50];

export const DEFAULT_PAGE_SIZE = PAGE_SIZES[0];

export const PAGE_SIZE_OPTIONS: SelectSheetOption[] = PAGE_SIZES.map(
  (size) => ({ value: String(size), label: String(size) }),
);

export const PAGE_SIZE_LABEL = "Rows per page";

export const BASE_FILTER_OPTIONS: ProgressFilterOption[] = [
  { value: "all", label: "All" },
  { value: "deposit", label: "Deposits" },
  { value: "withdrawal", label: "Withdrawals" },
  { value: "interest", label: "Interest" },
];

export const CASHBACK_FILTER_OPTION: ProgressFilterOption = {
  value: "cashback",
  label: "Cashback",
};

export const ALL_TYPES_LABEL = "All types";

export const CORRECTION_FALLBACK_DETAIL = "Older cashback correction";

export const EXPLANATIONS = {
  deposit: "Your own money moved in. It adds to net contributed.",
  withdrawal:
    "Your own money moved out. It lowers net contributed first, then retained earnings.",
  tradeBuy:
    "This cash paid for a trade, so the trade owns this entry. Change it from the trade.",
  tradeSale:
    "This cash came from a trade, so the trade owns this entry. Change it from the trade.",
  expense: "This expense lowered the balance.",
  olderExpense:
    "Recorded before cashback was added automatically, so its cashback did not change the balance. Any cashback that reached this account is its own entry.",
  interest: "Net interest is what reached the balance.",
  cashback:
    "You added this cashback, so it raised the balance like any income.",
  expenseCashback:
    "This cashback came with the expense and raised the balance on the same date. Change it from the expense.",
  cashbackBuy:
    "Cashback paid part of this buy, so it counts towards invested cashback. Your savings balance did not change.",
  payout:
    "This cashback was paid into another account, so your savings balance did not change.",
  correction:
    "An older correction to your cashback records. It never changed this balance.",
};

export const EMPTY_RESULTS_TEXT = "No entries match your search or filter.";

export const NEUTRAL_LEGEND = "— means the savings balance didn't change.";

// Delete sits apart on the left, so the order is the reverse of the row menu's.
export const DETAIL_BUTTONS: DetailButton[] = [
  { id: "delete", label: "Delete", type: ButtonTypes.link, tone: "danger" },
  { id: "duplicate", label: "Duplicate", type: ButtonTypes.secondary },
  { id: "edit", label: "Edit", type: ButtonTypes.primary },
];

export const INTERACTIVE_SELECTOR = "a, button, [role='menu']";
